import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Tabs, Tab, Box } from '@mui/material';

const LoginSignupPopup = ({ open, onClose }) => {
    const [activeTab, setActiveTab] = useState(0);
    const [loginData, setLoginData] = useState({ email: '', password: '' });
    const [signupData, setSignupData] = useState({ email: '', password: '', confirmPassword: '' });

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const handleLoginChange = (e) => {
        const { name, value } = e.target;
        setLoginData({ ...loginData, [name]: value });
    };

    const handleSignupChange = (e) => {
        const { name, value } = e.target;
        setSignupData({ ...signupData, [name]: value });
    };

    const handleLoginSubmit = () => {
        // Handle login logic
        console.log('Login data:', loginData);
        onClose();
    };

    const handleSignupSubmit = () => {
        // Handle signup logic
        console.log('Signup data:', signupData);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{activeTab === 0 ? 'Login' : 'Sign Up'}</DialogTitle>
            <DialogContent>
                <Tabs value={activeTab} onChange={handleTabChange} centered>
                    <Tab label="Login" />
                    <Tab label="Sign Up" />
                </Tabs>
                {activeTab === 0 ? (
                    <Box component="form" noValidate autoComplete="off">
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="login-email"
                            label="Email"
                            name="email"
                            value={loginData.email}
                            onChange={handleLoginChange}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            type="password"
                            id="login-password"
                            label="Password"
                            name="password"
                            value={loginData.password}
                            onChange={handleLoginChange}
                        />
                    </Box>
                ) : (
                    <Box component="form" noValidate autoComplete="off">
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="signup-email"
                            label="Email"
                            name="email"
                            value={signupData.email}
                            onChange={handleSignupChange}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            type="password"
                            id="signup-password"
                            label="Password"
                            name="password"
                            value={signupData.password}
                            onChange={handleSignupChange}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            type="password"
                            id="signup-confirm-password"
                            label="Confirm Password"
                            name="confirmPassword"
                            value={signupData.confirmPassword}
                            onChange={handleSignupChange}
                        />
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">Cancel</Button>
                {activeTab === 0 ? (
                    <Button onClick={handleLoginSubmit} variant="contained">Login</Button>
                ) : (
                    <Button onClick={handleSignupSubmit} variant="contained">Sign Up</Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default LoginSignupPopup;